module.exports = __webpack_public_path__ + "img/femenino.b9ee4e8c.png";